import React from 'react'
import {observer} from 'mobx-react'
import {Box, Flex, Stack, Text, BaseButton} from '../../vanilla'
import {Link} from '../../components/link'
import {InfoLightIcon} from '../../components/icons'

interface NoAvailableDealsMessageProps {
  isExplorer: boolean
}

const NoAvailableDealsMessageContainer = ({isExplorer}: NoAvailableDealsMessageProps) => {
  return (
    <Flex justifyContent="center" paddingY="16px">
      <Box
        bg="white"
        marginX="20px"
        maxWidth={['full', 'half']}
        borderTopLeftRadius="base"
        borderTopRightRadius="base"
      >
        <Stack
          flexDirection={'row'}
          alignItems={'flex-start'}
          paddingX="16px"
          paddingY="12px"
          border="1px"
          borderColor="infoDark"
          borderRadius="base"
          bg="infoLight"
          gap="14px"
        >
          <Box minWidth="20px">
            <InfoLightIcon
              width="24px"
              height="24px"
              boxSize="44px"
              color="infoDark"
              fill="infoDark"
            />
          </Box>
          <Stack flexDirection={'column'} alignItems={'flex-start'}>
            <Text variant="heading1Bold">
              {isExplorer
                ? "Sorry, Meal Deals aren't available right now"
                : "Sorry, this deal isn't available right now"}
            </Text>
            <Text variant="text6">
              {isExplorer
                ? "They may be out of stock or no longer available, check back later."
                : "It may be out of stock or or no longer available, but we have plenty more deals we think you'll love."}
            </Text>
          </Stack>
        </Stack>
        <Stack
          paddingX="16px"
          paddingY="20px"
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          gap="16px"
        >
          <BaseButton as={Link} to="/offers" width="full" size="lg">
            <Text variant="text3Bold">{isExplorer ? "View Offers" : "Continue Shopping"}</Text>
          </BaseButton>
          {!isExplorer && (
            <Text
              as={Link}
              variant="text4"
              to="/meal-deals"
              textDecoration="underline"
              color={{default: 'accent3', hover: 'accent3Light'}}
            >
              View More Deals
            </Text>
          )}
        </Stack>
      </Box>
    </Flex>
  )
}

export const NoAvailableDealsMessage = observer(NoAvailableDealsMessageContainer)
